import dayjs from 'dayjs';

export default (): string => dayjs().startOf('day').toISOString();
